import React, { Suspense } from 'react';
import Loader from '../loader';
import styles from './styles.module.scss';

const CodeSplitLoader = (
  <div
    className={`flex flex-col h-full w-full flex-1 items-center justify-center ${styles.codeSplitLoader}`}
  >
    <Loader />
  </div>
);

export default function CodeSplit(Component, props) {
  return (
    <Suspense fallback={CodeSplitLoader}>
      <Component {...props} />
    </Suspense>
  );
}
